<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16ichUw/tc-custom/9780226803111.jpg?1733105027611" alt="This image is the cover for the book Infidel Poetics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Infidel Poetics
      </h1>
      <p class="bookDescription body article font2">
        <p>Poetry has long been regarded as the least accessible of literary genres. But how much does the obscurity that confounds readers of a poem differ from, say, the slang that seduces listeners of hip-hop?  <i>Infidel Poetics</i> examines not only the shared incomprensibilities of poetry and slang, but poetry's genetic relation to the spectacle of underground culture.<br/><br/> Charting connections between vernacular poetry, lyric obscurity, and types of social relations—networks of darkened streets in preindustrial cities, the historical underworld of taverns and clubs, the subcultures of the avant-garde—Daniel Tiffany shows that obscurity in poetry has functioned for hundreds of years as a medium of alternative societies.  For example, he discovers in the submerged tradition of canting poetry and its eccentric genres—thieves’ carols, drinking songs, beggars’ chants—a genealogy of modern nightlife, but also a visible underworld of social and verbal <i>substance</i>, a demimonde for sale.<br/><br/> Ranging from Anglo-Saxon riddles to Emily Dickinson, from the icy <i>logos</i> of Parmenides to the monadology of Leibniz, from Mother Goose to Mallarmé, <i>Infidel Poetics</i> offers an exhilarating account of the subversive power of obscurity in word, substance, and deed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Tiffany
      </h2>
      
      <p class="authorDescription body article"><P><B>Daniel Tiffany</B> is the author of five books of poetry and literary criticism, including <I>Toy Medium: Materialism and Modern Lyric</I> (named one of the "Best Books of 2000" by the Los Angeles Times) and the forthcoming <I>Dandelion Clock</I>. In addition, he has published&#160;translations of works from French, Greek, and Italian. His poems have appeared in <I>Tin House</I>, Boston Review, and the Paris Review, and his critical essays on poetry and poetics have been published in Critical Inquiry, PMLA, and Modernism/Modernity.&#160; He has held residencies at the MacDowell Colony and the Karolyi Foundation in France and been the recipient of a Whiting Fellowship. He teaches at the University of Southern California in Los Angeles.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1899f7f6